export default __webpack_public_path__ + "static/media/christmasBackground.e854a54f.jpg";